<template>
    <div class="niste-clan">
      <div>{{ $t('no_permission.message') }}</div>
      <a @click="sendTwoBack()">{{ $t('no_permission.return_button') }}</a>
    </div>
  </template>
  
  <script>
  export default {
      methods:{
        sendTwoBack()
        {
            this.$router.go(-1)
        }
      }
  
  }
  </script>
  
  <style>
  
  </style>